// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1ORZR","productName":"Table_productName__-RSOG"};